import { Component } from 'react';

/**
 * @todo No reasoning has been given for calling `changeContext` after a
 * 500ms timeout, but it's possibly because - due to the fact blackbox
 * only loads once the rest of app.jsx has loaded - the original developer
 * was finding `window.cdApi` didn't exist in time for the initial View
 * render in the react app.
 * By investigating and refactoring the initial load of blackbox and the
 * app codebase as a whole, we may be able to remove the need for an
 * arbitrary timeout, which is still going to be hit-and-miss on slow
 * connection speeds.
 */
function changeBioCatchContext(context) {
  if (window.cdApi) {
    setTimeout(() => window.cdApi.changeContext(context), 500);
  }
}

/**
 * Sets the global BioCatch context label on mount
 */
class BioCatchContext extends Component {
  componentDidMount() {
    changeBioCatchContext(this.props.context);
  }

  render() {
    return this.props.children;
  }
}

export { BioCatchContext };
